import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {filter, map} from 'lodash';
import ButtonList from 'shared/components/button-list';
import switchAccount from 'shared/actions/switch-account';
import {ImpostorModeContext} from 'src/components/ImpostorModeContext';

const propTypes = {
  switchUser: PropTypes.func.isRequired,
};

const ConnectionsList = ({switchUser}) => {
  const impostorModeContext = useContext(ImpostorModeContext);
  const acceptedConnections = filter(impostorModeContext.userConnections, {status: 'accepted'});

  return (
    <ButtonList
      buttons={map(acceptedConnections, (connection) => {
        const {connectedUser} = connection;
        return {
          onClick: () => switchUser(connectedUser._id),
          text: connectedUser.firstName,
          selected: connectedUser.impersonatedUser,
        };
      })}
    />
  );
};

ConnectionsList.propTypes = propTypes;

const mapDispatchToProps = (dispatch) => ({
  switchUser: (id) =>
    dispatch(switchAccount(id, 'Switch account in impostor toolbar connections list')),
});

export default connect(null, mapDispatchToProps)(ConnectionsList);
